import { createPlatformAdminRepository } from '@upadelmatch/core/platform-admin'
import { db } from '@/core/firebase/client'

// Shared implementation (retry-through-hydration-race, fail-closed, legacy
// map-format support) lives in @upadelmatch/core/platform-admin; this file
// only binds it to THIS app's Firestore instance (separate Firebase project —
// its own `platform_config/admins` doc, decision 2026-07-04). It sits under
// features/auth/api/ because that is this app's sanctioned Firestore-SDK
// boundary.
export const platformAdminRepository = createPlatformAdminRepository(db)
